/**********Sticky header ************ */
document.addEventListener("DOMContentLoaded", onDOMReady);
function onDOMReady() {
    let menuHeader = document.querySelector('header');
    let body = document.querySelector('body');
    if(menuHeader && body) {
        const scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        window.addEventListener('scroll', onWindowScroll);
        function onWindowScroll() {
            if(window.document.scrollingElement.scrollTop > 120 && scrollHeight > window.innerHeight + 200){
                menuHeader.classList.add("sticky");
                body.classList.add("sticky-margin-top");
            } else {
                body.classList.remove("sticky-margin-top");
                menuHeader.classList.remove("sticky")
            }
        }
    }
}

/* **** Main menu **** */
function mainMenuHandler() {
    const mainMenu = document.querySelector('.main-menu');
    if (!mainMenu) return;
    const menuItems = mainMenu.querySelectorAll('.main-menu__list__item');
    for(let i = 0; i < menuItems.length; i++) {
        if (menuItems[i].classList.contains('current')) break;
        menuItems[i].classList.add('selected');
    }
}
mainMenuHandler();

document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('.submenu-toggle');
    
    if (!toggles.length) return;
    
    toggles.forEach((btn) => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            
            const currentLi = btn.closest('li.menu-item-has-children');
            if (!currentLi) return;
            
            const currentSubmenu = currentLi.querySelector('.sub-menu');
            
            document.querySelectorAll('li.menu-item-has-children.open').forEach((li) => {
                if (li !== currentLi) {
                    li.classList.remove('open');
                    
                    const toggle = li.querySelector('.submenu-toggle');
                    if (toggle) toggle.classList.remove('active');
                    
                    const submenu = li.querySelector('.sub-menu');
                    if (submenu) submenu.style.maxHeight = '0';
                }
            });
            
            const isOpen = currentLi.classList.toggle('open');
            btn.classList.toggle('active', isOpen);
            
            if (currentSubmenu) {
                currentSubmenu.style.maxHeight = isOpen
                    ? currentSubmenu.scrollHeight + 'px'
                    : '0';
            }
        });
    });
    
    window.addEventListener('resize', () => {
        if (window.innerWidth > 1023) {
            document.querySelectorAll('.sub-menu').forEach((el) => {
                if (el instanceof HTMLElement) {
                    el.style.maxHeight = '';
                }
            });
        }
    });
});

/* **** Auto resize textarea field **** */
export class ResizeTextArea {
    constructor() {
        this.textarea = document.querySelector('textarea');
        this.rows = this.textarea.getAttribute('rows');
        this.textarea.addEventListener('input', this.autosize.bind(this));
    }

    autosize() {
        const previousRows = this.rows;
        const lines = this.textarea.value.split('\n').length;
        const characters = this.textarea.value.length;
        const rows = Math.max(lines, Math.ceil(characters / this.textarea.cols));
        if (rows !== previousRows) {
            this.textarea.setAttribute('rows', rows);
            this.rows = rows;
            this.textarea.dispatchEvent(new Event('change'));
        }
    }
}

/* **** Burger **** */
const burgerHandler = () => {
    const burgerBtn = document.querySelector('.burger-menu');
    const menu = document.querySelector('.main-menu-wrapper');
    const body = document.body;
    const html = document.documentElement;
    
    if (!burgerBtn || !menu) return;
    
    let scrollPosition = 0;
    
    const setAria = (isOpen) => {
        burgerBtn.setAttribute('aria-expanded', String(isOpen));
        burgerBtn.setAttribute('aria-label', isOpen ? 'Закрыть меню' : 'Открыть меню');
    };
    
    const handleMenu = () => {
        const isOpen = burgerBtn.classList.toggle('show');
        menu.classList.toggle('show');
        body.classList.toggle('show');
        
        setAria(isOpen);
        
        if (isOpen) {
            scrollPosition = window.scrollY;
            html.classList.add('show');
            
            document.querySelectorAll('.main-menu.show a').forEach(link =>
                link.addEventListener('click', closeMenu)
            );
            
            document.addEventListener('keydown', handleEscape);
        } else {
            html.classList.remove('show');
            window.scrollTo({ top: scrollPosition, behavior: 'instant' });
            
            removeListeners();
        }
    };
    
    const closeMenu = () => {
        burgerBtn.classList.remove('show');
        menu.classList.remove('show');
        body.classList.remove('show');
        html.classList.remove('show');
        
        setAria(false);
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        
        removeListeners();
    };
    
    const handleEscape = (event) => {
        if (event.key === 'Escape') {
            closeMenu();
        }
    };
    
    const removeListeners = () => {
        document.querySelectorAll('.main-menu a').forEach(link =>
            link.removeEventListener('click', closeMenu)
        );
        document.removeEventListener('keydown', handleEscape);
    };
    
    burgerBtn.addEventListener('click', handleMenu);
    window.addEventListener('unload', removeListeners);
};

burgerHandler();

document.addEventListener("DOMContentLoaded", function () {
    const groups = [
        '.company-phones__item',
        '.company-faxes__item',
        '.company-emails__item',
    ];
    
    groups.forEach(selector => {
        const items = document.querySelectorAll(selector);
        if (!items.length) return;
        
        let width = 0;
        
        items.forEach(item => {
            if (!item) return;
            
            const label = item.querySelector('span');
            if (!label) return;
            
            const content = label.textContent.trim();
            if (content && width === 0) {
                label.style.display = 'inline-block';
                width = label.offsetWidth;
            }
        });
        
        if (!width) return;
        
        items.forEach(item => {
            if (!item) return;
            
            const label = item.querySelector('span');
            if (!label) return;
            
            const content = label.textContent.trim();
            if (!content) {
                label.style.display = 'inline-block';
                label.style.width = `${width}px`;
            }
        });
    });
});

// document.addEventListener("DOMContentLoaded", () => {
//     const main = document.querySelector("main");
//     const sections = main.querySelectorAll("section");
//     if (!sections.length) return;
//
//     const lastSection = sections[sections.length - 1];
//     lastSection.classList.add("section-before-footer");
// });

/* **** Toast **** */
import { Toast } from 'bootstrap';

const toastContainer = document.querySelector('.toast');
const toastBody = toastContainer.querySelector('.toast-body');
const toastInit = new Toast(toastContainer, {
    animation: true,
    autohide: true,
    delay: 3000
});
const setMessage = (event) => {
    const message = event.detail.apiResponse.message;
    toastBody.innerHTML = '';
    toastBody.innerHTML += '<span>' + message + '</span>';
}

/* **** Error **** */
document.addEventListener( 'wpcf7invalid', function( event ) {
    toastContainer.classList.remove('success');
    toastContainer.classList.add('error');
    setMessage(event);
    toastInit.show();
}, false );
document.addEventListener( 'wpcf7spam', function( event ) {
    toastContainer.classList.remove('success');
    toastContainer.classList.add('error');
    setMessage(event);
    toastInit.show();
}, false );
document.addEventListener( 'wpcf7mailfailed', function( event ) {
    toastContainer.classList.remove('success');
    toastContainer.classList.add('error');
    setMessage(event);
    toastInit.show();
}, false );

/* **** Success **** */
document.addEventListener( 'wpcf7mailsent', function( event ) {
    toastContainer.classList.remove('error');
    toastContainer.classList.add('success');
    setMessage(event);
    toastInit.show();
}, false );

/* **** Form Emails Changes **** */
export function nitgFormEmailsChanges(ids, formId) {
    const form = document.querySelector(`[data-wpcf7-id="${formId}"] form`);
    if (!form) {
        return
    }
    
    form.addEventListener('submit', function (event) {
        const form = event.target;
        const hiddenField = form.querySelector('[name="employee_emails"]');
        
        if (hiddenField) {
            try {
                hiddenField.value = ids.join(',');
                
                hiddenField.dispatchEvent(new Event('input'));
                hiddenField.dispatchEvent(new Event('change'));
                
            } catch (e) {
                console.warn('Failed to set employee_emails', e);
            }
        }
    }, true);
}
